;
$(function() {
    if (!$(".js-aside").length) return;

    let $aside = $(".js-aside");
    let $footer = $("footer");
    let $container = $aside.parent();
    let containerPadding = parseInt($container.css("padding-bottom"));
    // let asideStartTop = $aside.offset().top - $(window).scrollTop();
    // let asideBottom = $aside.offset().top + $aside.outerHeight() - $(window).scrollTop();
    let navBottom = $(".js-navigation").offset().top + $(".js-navigation").outerHeight() - $(window).scrollTop();
    let asideTop, containerTop, asideBottom, footerTop;

    // let footerTop = $footer.offset().top;
    // let isFixed = (footerTop + containerPadding) > asideBottom;

    getVariables();

    function getVariables() {
        asideTop = $aside.offset().top - $(window).scrollTop();
        containerTop  = $container.offset().top - $(window).scrollTop();
        asideBottom = asideTop + $aside.outerHeight();
        footerTop = $footer.offset().top - $(window).scrollTop();
    }

    setAsidePosition();

    // if (isFixed) {
    //     fixAside();
    // }

    // function unfixAside() {
    //     $aside.addClass("aside_static");
    //     $container.addClass("container__item_align_bottom");
    //     isFixed = false;
    // };

    // function fixAside() {
    //     $aside.removeClass("aside_static");
    //     $container.removeClass("container__item_align_bottom");
    //     isFixed = true;
    // };

    $(window).scroll(setAsidePosition);
    

    function setAsidePosition() {
        // let asideTop = $aside.offset().top - $(window).scrollTop();
        // let containerTop  = $container.offset().top - $(window).scrollTop();

        // asideBottom = asideTop + $aside.outerHeight();
        // footerTop = $footer.offset().top - $(window).scrollTop();
        getVariables();

        // console.log(`asideTop: ${asideTop}, navBottom: ${navBottom}`);

        if (asideTop <= navBottom && asideBottom < footerTop) {
            $aside.addClass("aside_fixed");
        }

        getVariables();

        if (asideBottom >= footerTop) {
            $container.addClass("container__column_align_bottom");
            $aside.removeClass("aside_fixed");
        }

        if (asideTop > navBottom /*&& asideBottom < footerTop*/) {
            $container.removeClass("container__column_align_bottom");
            $aside.addClass("aside_fixed");
        }

        if (containerTop >= navBottom) {
            $aside.removeClass("aside_fixed");            
        }

    }
});



// WEBPACK FOOTER //
// ./common.blocks/aside/aside.js